// Check for required environment variables
const required = [
  "REACT_APP_API_URL",
  "REACT_APP_STRIPE_PUBLISHABLE_KEY",
  "REACT_APP_GA4_MEASUREMENT_ID",
];
const missing = required.filter((key) => !process.env[key]);

if (missing.length) {
  throw new Error(
    `Missing required environment variable(s): ${missing.join(", ")}`
  );
}

export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  ga4MeasurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID,
};